import React, { useEffect } from "react";
import encHex from "crypto-js/enc-hex";
import HmacSHA256 from "crypto-js/hmac-sha256";

import { defined, notNull } from "@formant/core/common/defined";
import { isGdprRegion } from "@formant/core/common/isGdprRegion";

import { ducalisAppId, ducalisBoardId, ducalisSecret } from "../config";
import { useStores } from "../context/StoreContext";
import { DucalisButton, DucalisChangeLog } from "./ducalis.styles";

const injector = (
    hash: string,
    email: string,
) => `!(function (b, c, f, d, a, e) {
    b.dclsPxl ||
      ((((d = b.dclsPxl =
        function () {
          d.callMethod
            ? d.callMethod.apply(d, arguments)
            : d.queue.push(arguments);
        }).push = d).queue = []),
      ((a = c.createElement("script")).async = !0),
      (a.src = f),
      (e = c.getElementsByTagName("script")[0]).parentNode.insertBefore(
        a,
        e
      ));
  })(window, document, "https://ducalis.io/js/widget.js");
  dclsPxl("initWidget", {
    appId: "${ducalisAppId}", 
    boardId: "${ducalisBoardId}",
    selector: "#ducalis-notification",
    user: {
      email: "${email}",
      hash: "${hash}"
    }
  });`;

export const Ducalis = () => {
    const { userStore } = useStores();
    const user = userStore.authenticated();

    useEffect(() => {
        if (
            !user ||
            isGdprRegion(user.region) ||
            !ducalisAppId ||
            !ducalisBoardId ||
            !ducalisSecret
        ) {
            return;
        }
        const hash = HmacSHA256(defined(user.email), ducalisSecret);
        const body = notNull(document.querySelector("body"));
        const script = document.createElement("script");
        script.innerHTML = injector(hash.toString(encHex), defined(user.email));
        body.appendChild(script);
    }, [userStore, user]);

    if (
        !ducalisAppId ||
        !ducalisBoardId ||
        !ducalisSecret ||
        (user && isGdprRegion(user.region))
    ) {
        return null;
    }

    return (
        <DucalisChangeLog className="ducalis-changelog-widget">
            <DucalisButton id="ducalis-notification" data-testid="whats-new">
                Updates
            </DucalisButton>
        </DucalisChangeLog>
    );
};
